// extracted by mini-css-extract-plugin
export default {"dynamicInput":"Selector_dynamicInput__0AYPR","dynamicButton":"Selector_dynamicButton__aCvZq"};